﻿// based on ngx-tooltip

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from './tooltip.directive';
import { TooltipContentComponent } from './tooltip-content.component';

import {TooltipHeaderComponent} from './tooltip-header/tooltip-header.component';
import {TooltipFooterComponent} from './tooltip-footer/tooltip-footer.component';
import {BankStatementTooltipComponent} from './bank-statement-tooltip/bank-statement-tooltip.component';
import {DriversLicenseTooltipComponent} from './drivers-license-tooltip/drivers-license-tooltip.component';
import {LoanSummaryTooltipComponent} from './loan-summary-tooltip/loan-summary-tooltip.component';
import {PayStubTooltipComponent} from './paystub-tooltip/paystub-tooltip.component';
import {VoidedCheckTooltipComponent} from './voided-check-tooltip/voided-check-tooltip.component';
import {W2TooltipComponent} from './w2-tooltip/w2-tooltip.component';
import {GenericHTMLTooltipComponent} from './generic-HTML-tooltip/generic-HTML-tooltip.component';
import {PropertyTypeTooltipComponent} from './property-type-tooltip/property-type-tooltip.component';
import {PurchaseDocumentsTooltipComponent} from './purchase-documents-tooltip/purchase-documents-tooltip.component';
import {MilitaryServiceMembersTooltipComponent}
from './military-service-members-tooltip/military-service-members-tooltip.component';
import {MaritalStatusTooltipComponent} from './marital-status-tooltip/marital-status-tooltip.component';
import {CoBorrowerTooltipComponent} from './co-borrower-tooltip/co-borrower-tooltip.component';
import {VerifyCreditHistoryTooltipComponent}
from './verify-credit-history-tooltip/verify-credit-history-tooltip.component';
import {CreditScoreTooltipComponent} from './credit-score-tooltip/credit-score-tooltip.component';
import { DownPaymentTooltipComponent } from './down-payment-tooltip/down-payment-tooltip.component';
import { HomeownersAssociationTooltipComponent } from './homeowners-association-tooltip/homeowners-association-tooltip.component';
import {CreditAuthorizationTooltipComponent}
from './credit-authorization-tooltip/credit-authorization-tooltip.component';
import {PropertyTaxTooltipComponent} from './property-tax-tooltip/property-tax-tooltip.component';
import {VAFundingFeesTooltipComponent} from './va-funding-fees-tooltip/va-funding-fees-tooltip.component';
import {RefinanceGoalsTooltipComponent} from './refinance-goals-tooltip/refinance-goals-tooltip.component';
import {PropertyPurposeTooltipComponent} from './property-purpose-tooltip/property-purpose-tooltip.component';
import {MonthlyMortgagePaymentTooltipComponent} from './monthly-mortgage-payment-tooltip/monthly-mortgage-payment-tooltip.component';
import {VAFixedRateTooltipComponent} from './VA-fixed-rate-tooltip/VA-fixed-rate-tooltip.component';
import {ConventionalFixedRateTooltipComponent} from './conventional-fixed-rate-tooltip/conventional-fixed-rate-tooltip.component';

export * from './tooltip.directive';
export * from './tooltip-content.component';
export {HTMLTooltipTypes} from './generic-HTML-tooltip/generic-HTML-tooltip-types';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TooltipDirective,
    TooltipContentComponent,
    TooltipHeaderComponent,
    TooltipFooterComponent,
    GenericHTMLTooltipComponent,
    BankStatementTooltipComponent,
    DriversLicenseTooltipComponent,
    LoanSummaryTooltipComponent,
    PayStubTooltipComponent,
    VoidedCheckTooltipComponent,
    W2TooltipComponent,
    PropertyTypeTooltipComponent,
    PurchaseDocumentsTooltipComponent,
    MilitaryServiceMembersTooltipComponent,
    MaritalStatusTooltipComponent,
    CoBorrowerTooltipComponent,
    VerifyCreditHistoryTooltipComponent,
    CreditScoreTooltipComponent,
    DownPaymentTooltipComponent,
    CreditAuthorizationTooltipComponent,
    PropertyTaxTooltipComponent,
    VAFundingFeesTooltipComponent,
    RefinanceGoalsTooltipComponent,
    PropertyPurposeTooltipComponent,
    MonthlyMortgagePaymentTooltipComponent,
    VAFixedRateTooltipComponent,
    ConventionalFixedRateTooltipComponent,
    HomeownersAssociationTooltipComponent
  ],
  exports: [
    TooltipDirective,
    TooltipContentComponent,
    TooltipHeaderComponent,
    TooltipFooterComponent,
    GenericHTMLTooltipComponent
  ],
  entryComponents: [
    TooltipContentComponent
  ]
})

export class TooltipModule {
}
